import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: PolicyModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="policy-modal-title" data-id="element-81">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-ink/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-82" />

      {/* Panel */}
      <div className="relative bg-cream text-ink rounded-3xl border border-taupe shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col" data-id="element-83">
        {/* Header */}
        <div className="flex items-start justify-between gap-4 p-6 sm:p-8 border-b border-taupe/60" data-id="element-84">
          <h2 id="policy-modal-title" className="font-serif text-3xl sm:text-4xl leading-tight pr-4" data-id="element-85">
            {title}
          </h2>
          <button onClick={onClose} className="shrink-0 w-10 h-10 flex items-center justify-center rounded-full border border-taupe hover:bg-coral hover:text-white hover:border-coral transition-colors" aria-label="Cerrar" data-id="element-86">
            <X className="w-5 h-5" data-id="element-87" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 sm:p-8 space-y-5 text-ink/80 leading-relaxed" data-id="element-88">
          {children}
        </div>
      </div>
    </div>;
}